import { PayPalScriptProvider, PayPalButtons, PayPalButtonsComponentProps, ReactPayPalScriptOptions } from "@paypal/react-paypal-js";
import { Plan } from "components/types/Types";
import Config from "config/config";
import { ResponseData, useHttpUtil } from "context/HttpContext";

export default function Paypal(props: { plan: Plan, isLargeButton ?: boolean, onSuccessCallback ?: (id: string) => void, onCancelCallback?: Function}){
    const { plan,isLargeButton = false, onSuccessCallback, onCancelCallback} = props ;

    const httpUtil = useHttpUtil();

    const payOptions : ReactPayPalScriptOptions = {
        clientId: Config.paypalClientId,
        // environment: Config.paypalEnv as "production" | "sandbox",
        // disableFunding: "paylater",
        locale: "en_US",
        // buyerCountry: "US",
        currency: "USD",
        vault: true,
        intent: "subscription"
    }

    const btnStyles : PayPalButtonsComponentProps['style'] = {
        layout: "vertical",
        color: "blue",
        label: "subscribe",
        borderRadius: isLargeButton ? 10 : 5,
        height: isLargeButton ? 55 : 30
    }

    const createSubscription: PayPalButtonsComponentProps["createSubscription"] = async (data, actions) => {
        // console.info('createSubscription', data, plan)

        const resData : ResponseData = await httpUtil.post('/biz/plan/order/create',{
            planId : plan.id,
            payType : 2
        });
        if(!resData.errCode){
            return actions.subscription.create({
                "plan_id": plan.paypalPlanId as string, // "P-1C481776S0516902YNBACOTA",
                "custom_id" : resData.data
            });
        }
        return "" ;
    }

    const onApprove: PayPalButtonsComponentProps["onApprove"] = async (data) => {
        // console.info(data, `You have successfully subscribed to ${data.subscriptionID}`); // Optional message given to subscriber
        onSuccessCallback && onSuccessCallback(data.subscriptionID as string);
    }

    const onCancel: PayPalButtonsComponentProps["onCancel"] = (data) => {
        // console.info('cancel', data)
        onCancelCallback && onCancelCallback();
    }

    const onError: PayPalButtonsComponentProps["onError"] = (err) => {
        // console.info('onError', err)
        onCancelCallback && onCancelCallback();
    }

    return (
        <PayPalScriptProvider options={ payOptions }>
            <PayPalButtons style={ btnStyles } 
                createSubscription={ createSubscription } 
                onApprove={ onApprove }
                onCancel={ onCancel }
                onError={ onError }
                displayOnly={["vaultable"]}
                // fundingSource={"paypal"}
            />
        </PayPalScriptProvider>
    )
}
